import { useComposablePage } from '@bnnvara/composable';
import get from 'lodash/get';
import React from 'react';

import withBrandedComposablePage from '../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../layouts/ComposablePageLayout';
import ContentPageQuery from './ContentPage.gql';
import aboutPage from './data/AboutPage.json';
import cardOverviewPageData from './data/CardOverviewPage.json';
import defaultPageData from './data/ContentPage.json';
import notFoundPageData from './data/ContentPageNotFound.json';

const getPageData = (data) => {
  if (get(data, 'brand.page.slug') === 'over') {
    return aboutPage;
  }

  if (get(data, 'brand.page.type') === 'cardOverview') {
    return cardOverviewPageData;
  }

  return defaultPageData;
};

const ContentPage = () => {
  const { data, render } = useComposablePage();
  const pageData = getPageData(data);

  const content = render(pageData, notFoundPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: ContentPageQuery,
  isFound: (data) => data.brand.page,
})(ContentPage);
